<template>
  <div class="promo-carousel-wrapper">
    <div class="promo-carousel-controls" ref="NavArrows">
      <div class="prev" @click="Prev" aria-label="previous slide button" role="button" tabindex="0"></div>
      <div class="next" @click="showNext" aria-label="next slide button" role="button" tabindex="0"></div>
      <button class="play-pause" @click="isPlaying" :class="[settings.autoplay ? 'pause' : 'play']"><span class="screen-reader-only">Play/Pause</span></button>
    </div>
    <VueSlickCarousel class="promo-carousel" v-bind="settings" ref="tinySlider">
      <div v-for="(slide, index) in slides" :key="index" class="promo-carousel-slide">
        <picture>
          <source v-for="s in slide.srcsets" :key="s.media" :srcset="getSrc(s.srcset)" :media="s.media">
          <img class="promo-carousel__img" :src="getSrc(slide.src)" :alt="slide.alt">
        </picture>
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'promo-carousel',
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      slides: [
        {
          src: 'sang-pal.png',
          srcsets: [
            {
              srcset: 'sang-pal.png',
              media: '(min-width: 1920px)',
            },
            {
              srcset: 'sang-pal.png',
              media: '(min-width: 1024px)',
            },
            {
              srcset: 'sang-pal.png',
              media: '(min-width: 768px)',
            },
            {
              srcset: 'sang-pal.png',
              media: '(max-width: 767px)',
            },
          ],
          alt: 'New Paradise Paloma and Berry Sparkle Sangria',
        },
        {
          src: 'berry-sparkle-sangria.png',
          srcsets: [
            {
              srcset: 'berry-sparkle-sangria.png',
              media: '(min-width: 1920px)',
            },
            {
              srcset: 'berry-sparkle-sangria.png',
              media: '(min-width: 1024px)',
            },
            {
              srcset: 'berry-sparkle-sangria.png',
              media: '(min-width: 768px)',
            },
            {
              srcset: 'berry-sparkle-sangria.png',
              media: '(max-width: 767px)',
            }
          ],
          alt: 'Berry Sparkle Sangria',
        },
        {
          src: 'paradise-paloma.png',
          srcsets: [
            {
              srcset: 'paradise-paloma.png',
              media: '(min-width: 1920px)',
            },
            {
              srcset: 'paradise-paloma.png',
              media: '(min-width: 1024px)',
            },
            {
              srcset: 'paradise-paloma.png',
              media: '(min-width: 768px)',
            },
            {
              srcset: 'paradise-paloma.png',
              media: '(max-width: 767px)',
            },
          ],
          alt: 'Paradise Paloma',
        }
      ],
      settings: {
        dots: false,
        edgeFriction: 0.35,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
      }
    }
  },
  methods: {
    getSrc(src) {
      if (!src) return '';
      return require('./../assets/sang-pal/' + src);
    },
    Prev() {
      if (this.$refs.tinySlider) this.$refs.tinySlider.prev();
    },
    showNext() {
      if (this.$refs.tinySlider) this.$refs.tinySlider.next();
    },
    isPlaying() {
      this.settings.autoplay = !this.settings.autoplay;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~tiny-slider/src/tiny-slider";
@import "./../variables";

.promo-carousel-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.promo-carousel {
  width: 100vw;
  margin: 0;
}

/* Remove 1–3px gap under slides (inline baseline spacing) */
.promo-carousel-slide,
.promo-carousel-slide picture {
  display: block;
  line-height: 0;
}

.promo-carousel__img {
  display: block;
  line-height: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  margin: 0;
}

.promo-carousel-controls {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 10; /* above carousel slides */

  div,
  button {
    width: 48px;
    height: 48px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
  }

  .prev {
    background-image: url("./../assets/arrow-left.png");
    transition: background-image 0.3s linear;
    left: 13px;
  }

  .next {
    background-image: url("./../assets/arrow-right.png");
    transition: background-image 0.3s;
    right: 13px;
  }

  .play-pause {
    position: absolute;
    border: none;
    border-radius: 50%;
    top: 18vw;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-size: 70%;
    background-position: center;

    &.play {
      background-image: url("./../assets/play_arrow.png");
    }

    &.pause {
      background-image: url("./../assets/pause.png");
    }

    @include breakpoint("tablet") {
      top: 22vw;
    }
  }

  &.bounce {
    .prev {
      background-image: url("./../assets/arrow-left-bounce.png");
      left: 13px;
    }

    .next {
      background-image: url("./../assets/arrow-right-bounce.png");
      right: 13px;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/CarouselPromo.vue